import { Cancel } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProcessStep } from '../../../common/enums/enums';

const StepsOptions = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  if (selectedFilters.dateFormat === 'completedOn')
    return <Typography>{ProcessStep.DONE}</Typography>;
  if (selectedFilters.selectedSteps.allSelected)
    return <Typography>{t('allOption')}</Typography>;
  return (
    <Chip
      size="small"
      onDelete={() =>
        setSelectedFilters(state => ({
          ...state,
          selectedSteps: {
            steps: [],
            allSelected: false,
          },
        }))
      }
      deleteIcon={<Cancel onMouseDown={event => event.stopPropagation()} />}
      label={`${selectedFilters.selectedSteps.steps.length} ${t('stepsChip')}`}
    />
  );
};

const StepsFilter = ({ selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const filteredSteps = Object.values(ProcessStep).filter(
    step => step !== ProcessStep.RESUME && step !== ProcessStep.TRANSFERRED
  );

  const handleSelectedSteps = e => {
    if (e.target.value.includes('all')) {
      setSelectedFilters(state => ({
        ...state,
        selectedSteps: {
          steps: filteredSteps,
          allSelected: true,
        },
      }));
    } else {
      setSelectedFilters(state => ({
        ...state,
        selectedSteps: {
          steps: e.target.value,
          allSelected: false,
        },
      }));
    }
  };
  return (
    <FormControl
      size="small"
      sx={{
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: (smallScreen && '100%') || 'calc(50% - 0.5rem)',
      }}
    >
      <InputLabel>{t('step')}</InputLabel>
      <Select
        label={t('step')}
        value={selectedFilters.selectedSteps.steps}
        onChange={handleSelectedSteps}
        multiple
        SelectDisplayProps={{
          'data-testid': 'stepsFilter',
        }}
        inputProps={{
          'data-testid': 'stepsFilterInput',
        }}
        MenuProps={{
          sx: { maxHeight: '200px' },
        }}
        disabled={selectedFilters.dateFormat === 'completedOn' ? true : false}
        renderValue={() => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            <StepsOptions
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
            />
          </Box>
        )}
      >
        <MenuItem value="all">{t('allOption')}</MenuItem>
        <Divider />
        {filteredSteps.map((step, index) => (
          <MenuItem key={index} value={step}>
            {step}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StepsFilter;
